import { render, staticRenderFns } from "./AudiobooksDetail.vue?vue&type=template&id=46dd9684&lang=html&"
import script from "./AudiobooksDetail.vue?vue&type=script&lang=js&"
export * from "./AudiobooksDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports